import { render } from "./loginWx.vue?vue&type=template&id=6bdc673d&scoped=true"
import script from "./loginWx.vue?vue&type=script&lang=js"
export * from "./loginWx.vue?vue&type=script&lang=js"

import "./loginWx.vue?vue&type=style&index=0&id=6bdc673d&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdc673d"]])

export default __exports__